<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs
        headline="Chi tiết báo cáo tiết dạy"
        :link="[{ text: 'Báo cáo tiết dạy', href: '/teacher-class-report' }]"
      />
    </div>
    <TeacherProfileHeader :isDetailShown="false" :avatarUpdateable="false" class="ma-4" />
    <v-card class="ma-4 mt-6 pa-4">
      <div class="d-flex justify-center flex-column align-center" v-if="fetchLoading">
        <v-progress-circular indeterminate color="primary" class="mb-4" />
        <div class="primary--text">Đang tổng kết dữ liệu...</div>
      </div>
      <div v-else>
        <div v-show="!slots.length">
          Hiện chưa có dữ liệu báo cáo tiết dạy cho tháng hiện tại
        </div>
        <div v-show="slots.length > 0">
          <!-- <div class="d-flex justify-end mb-4">
            <v-btn class="search-button" outlined color="success" @click="exportExcel">
              <v-icon left>mdi-file-excel</v-icon> Xuất Excel
            </v-btn>
          </div> -->
          <v-data-table :headers="tableHeader" :items="slots" :footer-props="footerTable" :key="tableKey" disable-sort>
            <template v-slot:[`item.date`]="{ item }">
              <div>{{ item.day | scheduleDay }} ({{ item.date | ddmmyyyy }})</div>
            </template>
            <template v-slot:[`item.day`]="{ item }">
              <div>{{ item.index | dayPeriod }}</div>
            </template>
            <template v-slot:[`item.index`]="{ item }">
              <div>{{ item.index }}</div>
            </template>
            <template v-slot:[`item.class`]="{ item }">
              <router-link style="text-decoration: none" :to="'/class/' + item.class.id">
                <div>{{ item.class.title }}</div>
              </router-link>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import TeacherProfileHeader from '@/modules/teacher/profile/TeacherProfileHeader'
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  components: {
    Breadcrumbs,
    TeacherProfileHeader
  },
  data() {
    return {
      slots: [],
      tableKey: Date.now(),
      fetchLoading: true,
      tableHeader: [
        {
          text: 'Ngày',
          value: 'date',
          width: '25%'
        },
        {
          text: 'Buổi',
          value: 'day'
        },
        {
          text: 'Tiết',
          value: 'index'
        },
        {
          text: 'Lớp',
          value: 'class'
        }
      ]
    }
  },
  computed: {
    footerTable() {
      let footer = {
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 20,
        'items-per-page-options': [10, 20, -1]
      }
      return footer
    }
  },
  async mounted() {
    await this.onFetchData()
  },
  methods: {
    ...mapActions('ClassNotes', ['fetchReportByTeacherDetail']),
    ...mapActions('teacher', ['fetchTeacher']),
    async onFetchData() {
      this.fetchLoading = true

      const teacherId = this.$route.params.id
      const date = this.$route.params.date
      await this.fetchTeacher(teacherId)
      this.slots = await this.fetchReportByTeacherDetail({
        date_gte: moment(date)
          .startOf('month')
          .toISOString(),
        date_lte: moment(date)
          .endOf('month')
          .toISOString(),
        teacher: teacherId,
        _sort: 'date:asc'
      })
      this.tableKey = Date.now()

      this.fetchLoading = false
    }
  }
}
</script>
